/*
* @Author: zhangzhitao
* @Date: 2019-05-27 13:38:43
* @Des:
 * @Last Modified by: zhenghong7
 * @Last Modified time: 2019-09-16 10:57:03
*/

<template>
  <div
    class="m-tips-page"
    :class="{'is-open':!isLock}"
  >
    <div class="m-tip-ct">
      <img
        src="../../../../assets/images/Default_bulb.png"
        alt=""
      >
      <span class="tips-tt">{{$t('management.dataView.tips')}}</span>
      <span class="tips-txt">{{$t('management.dataView.tips_ctx')}}</span>
      <span>
        <el-button
          type="primary"
          @click="handleOpenSysConfig"
        >{{$t('management.dataView.data_view_all_config')}}</el-button>
        <el-button
          type="default"
          @click="handleCloseTips"
        >{{$t('management.dataView.skip')}}</el-button>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tips-wrap',
  data () {
    return {
      isLock: true
    }
  },

  components: {},

  computed: {},

  mounted () {
    this.$root.$on('changeTipWidth', this.handleChangeTipWidth)
  },

  methods: {
    handleOpenSysConfig () {
      this.$emit('openSysConfig')
      // this.$root.$emit('closeTips')
    },
    handleCloseTips () {
      this.$root.$emit('closeTips')
    },
    handleChangeTipWidth (lock) {
      this.isLock = lock
    }
  }
}

</script>

<style lang="less" scoped>
.m-tips-page {
  width: calc(~"100% - 320px");
  height: 100%;
  background: #f5f5f5;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 5;
  &.is-open {
    width: 100%;
  }
  .m-tip-ct {
    width: 380px;
    height: 300px;
    text-align: center;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    .tips-tt {
      font-size: 22px;
      color: rgba(0, 0, 0, 0.9);
      line-height: 32px;
      padding: 8px 0;
      display: block;
    }
    .tips-txt {
      display: block;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.4);
      line-height: 20px;
      margin-bottom: 24px;
    }
  }
}
</style>
